import { defineMessages } from "react-intl";

export const formFieldItemText = defineMessages({
  fieldFailed: {
    defaultMessage: "“{label}” could not be displayed. Please refresh the page.",
    id: "FelS+a",
  },
});
